import { useAuth0 } from '@auth0/auth0-react';
import { AuthUser, getUserModules, UserModuleIDs } from '@enroller/utils';
import { Trans } from '@lingui/react/macro';
import { CircularProgress, Stack, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStatelessPut } from '../utils/useStatelessPut';

export const PaymentCompleted = () => {
  const { user } = useAuth0<AuthUser>();
  const userModules = useMemo<UserModuleIDs | undefined>(() => user && getUserModules(user), [user]);
  const putCourseReservation = useStatelessPut(`/student-portal/${userModules?.dealId}`);
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (userModules?.dealId) {
      putCourseReservation({
        data: {
          Deals: [
            {
              id: userModules.dealId,
              Deposit_paid: 'Yes',
            },
          ],
        },
      })
        .then(() => {
          navigate('/');
        })
        .catch(() => {
          setError(true);
        });
    }
  }, [navigate, putCourseReservation, userModules.dealId]);

  if (error) {
    return (
      <Stack direction="column" justifyContent="center" alignItems="center" sx={{ width: '100%', height: '100%' }} gap={2}>
        <ErrorOutlineIcon />
        <Typography>
          <Trans>Error trying to save payment information, please contact your agent</Trans>
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack direction="column" justifyContent="center" alignItems="center" sx={{ width: '100%', height: '100%' }} gap={2}>
      <CircularProgress />
      <Typography>
        <Trans>Payment completed, redirecting...</Trans>
      </Typography>
    </Stack>
  );
};
